export { default } from "./ZoomImage";